module.exports = __webpack_public_path__ + "media/icons/pdf-file-e56b3cb1.png";